<template>
    <section class="section about-area ptb_100">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-12 col-lg-6">
                    <!-- About Thumb -->
                    <div class="about-thumb text-center">
                        <img src="assets/img/about_thumb_1.jpg" alt="">
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <!-- About Content -->
                    <div class="about-content section-heading text-center text-lg-left pl-md-4 mt-5 mt-lg-0 mb-0">
                        <h2 class="mb-3">konsalting u oblasti procene vrednosti imovine</h2>
                        <p>Ponosni smo što našim klijentima pružamo visokokvalitetne usluge sa timom iskusnih procenitelja, dok nudimo razumne cene uz brzu isporuku. Posvećujemo izuzetnu pažnju detaljima i inovativnim rešenjima koje samo specijalizovana kompanija može pružiti. Pomažemo klijentima u rastu, izgradnji i uvećanju poslovne vrednosti.</p><br>
                        <p>Tokom desetogodišnje profesionalne karijere učestvovali smo u izradi preko 5.000 izveštaja o proceni vrednosti. Poslujemo u kancelarijama u Beogradu, Novom Sadu i Leskovcu. U timu imamo dva licencirana procenitelja i specijalistu inženjera energetske efikasnosti. Blisko sarađujemo sa ekspertima iz oblasti građevinarstva, ekonomije, mašinstva, softverskog inženjerstva. Prepoznali smo važnost digitalizacije i održivog razvoja, s toga aktivno razvijamo AVM i usavršavamo se na polju zelene gradnje i zelene energije.</p>
                        <!-- Counter Area -->
                        <div class="couter-area mt-5">
                            <!-- Single Counter -->
                            <div class="single-counter d-block d-md-inline-block m-4 m-md-2">
                                <div class="counter-inner">
                                    <!-- Counter Item -->
                                    <div class="counter-item d-inline-block mb-3">
                                        <span class="counter color-1 fw-7">5000</span><span class="color-1 fw-7">+</span>
                                    </div>
                                </div>
                                <h4 class="text-uppercase fw-7">Procena</h4>
                            </div>
                            <!-- Single Counter -->
                            <div class="single-counter d-block d-md-inline-block m-4 m-md-2">
                                <div class="counter-inner">
                                    <!-- Counter Item -->
                                    <div class="counter-item d-inline-block mb-3">
                                        <span class="counter color-2 fw-7">10</span><span class="color-2 fw-7">+</span>
                                    </div>
                                </div>
                                <h4 class="text-uppercase fw-7">Godina Iskustva</h4>
                            </div>
                            <!-- Single Counter -->
                            <div class="single-counter d-block d-md-inline-block m-4 m-md-2">
                                <div class="counter-inner">
                                    <!-- Counter Item -->
                                    <div class="counter-item d-inline-block mb-3">
                                        <span class="counter color-3 fw-7">3</span>
                                    </div>
                                </div>
                                <h4 class="text-uppercase fw-7">Kancelarije</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>
